import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { initialTaskManagerPeriodFilter } from "./FilterTypes/TaskManagerPeriodFilterType";

interface TaskManagerPeriodOption {
  label: string
  value: server.dto.TaskManagerPeriodFilters
};
const TaskManagerPeriodFilter = () => {
  const title = RESX.DateTime.Period;

  const options: TaskManagerPeriodOption[] = [
    { label: RESX.Task.AllTasks, value: "allTasks" },
    { label: RESX.Task.OnlyExpiredTasks, value: "onlyExpiredTasks" },
    { label: RESX.Task.OnlyFutureTasks, value: "onlyFutureTasks" }
  ];

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("taskManagerPeriod", {
    getTitle: () => title,
    renderSelection: (value) => <>{options.find(o => o.value === value.selectedTaskManagerPeriod)?.label}</>,
    hasValue: (value) => value.selectedTaskManagerPeriod != null,
    reset: () => initialTaskManagerPeriodFilter,
    areEqual: (a, b) => a.selectedTaskManagerPeriod === b.selectedTaskManagerPeriod
  });
  useEffect(() => {
    setInitialValue("taskManagerPeriod", initialTaskManagerPeriodFilter);
  }, []);

  const [selectedTaskManagerPeriod, setSelectedTaskManagerPeriod] = React.useState<TaskManagerPeriodOption>(options.find(f => f.value === initialTaskManagerPeriodFilter.selectedTaskManagerPeriod));

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onChange = (option: TaskManagerPeriodOption) => {
    let newSelectedOption: TaskManagerPeriodOption;
    if (option.value === selectedTaskManagerPeriod?.value) { newSelectedOption = undefined; } else { newSelectedOption = option; }

    setSelectedTaskManagerPeriod(newSelectedOption);
    setPopupOpen(false);
    setValue("taskManagerPeriod", {
      selectedTaskManagerPeriod: newSelectedOption?.value
    });
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedTaskManagerPeriod(options.find(f => f.value === getValue("taskManagerPeriod").selectedTaskManagerPeriod));
    setPopupOpen(true);
  };

  const onApplyFilter = (e?) => {
    e?.preventDefault();
    setValue("taskManagerPeriod", {
      selectedTaskManagerPeriod: selectedTaskManagerPeriod?.value
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={onApplyFilter}>
        <SelectableList
          noSearch
          selectedItems={selectedTaskManagerPeriod != null ? [selectedTaskManagerPeriod] : []}
          items={options}
          onItemToggled={onChange}
          getId={p => p.value}
          getName={b => b.label}
        />
      </form>}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default TaskManagerPeriodFilter;